import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Confirmation, PopupAction } from '../common';
import { SEND_MESSAGE } from './errorHandlingSlice';

export interface PopupDetailsState {
	message: string;
	open: boolean;
	confirmation: Confirmation;
}
const initialState: PopupDetailsState= {
	message: '',
	open: false,
	confirmation: 'disagree',
};

const popUpSlice = createSlice({
  name:'popup',
  initialState,
  reducers:{
    SHOW_POPUP_CONFIRMATION:(state, action:PayloadAction<any>):PopupDetailsState=>{
      return{
        ...state,
				message: action.payload,
				open: true,
				confirmation: 'disagree',
      }
    },
    HANDLE_POPUP_CONFIRMATION:(state, action:PayloadAction<any>):PopupDetailsState=>{
      return{
        ...state,
				message: '',
				open: false,
				confirmation: action.payload,
      }
    },
    RESET_POPUP_CONFIRMATION:(state, action:PayloadAction<any>):PopupDetailsState=>{
      return{
        ...state,
        ...initialState
      }
    }
  }
})

export const { SHOW_POPUP_CONFIRMATION ,HANDLE_POPUP_CONFIRMATION, RESET_POPUP_CONFIRMATION} = popUpSlice.actions
export default popUpSlice.reducer

export const resetPopup = () => async (dispatch: any) => {
	try {
    dispatch(RESET_POPUP_CONFIRMATION(null))
	} catch (error: any) {
    dispatch(SEND_MESSAGE({ message:error, type:'error'}));
	}
};

export const showPopup = (msg:any) => async (dispatch: any) => {
	try {
    dispatch(SHOW_POPUP_CONFIRMATION(msg))
	} catch (error: any) {
    dispatch(SEND_MESSAGE({ message:error, type:'error'}));
	}
};


export const handlePopup = (response: Confirmation) => async (dispatch: any) => {
	try {
    dispatch(HANDLE_POPUP_CONFIRMATION(response))
	} catch (error: any) {
    dispatch(SEND_MESSAGE({ message:error, type:'error'}));
	}
};

